(() => {
  function initCart(root) {
    if (root.dataset.cartReady) return;
    root.dataset.cartReady = 'true';
    const form = root.querySelector('.nwan-cart__layout');
    if (!form) return;
    const all = form.querySelector('[data-select-all]');
    const picks = [...form.querySelectorAll('[data-select-item]')];
    const remove = form.querySelector('[data-remove-selected]');
    const update = form.querySelector('[data-update-cart]');
    const submitUpdate = () => form.requestSubmit(update);

    function syncSelection() {
      const selected = picks.filter((pick) => pick.checked).length;
      all.checked = selected === picks.length;
      all.indeterminate = selected > 0 && selected < picks.length;
      remove.disabled = selected === 0;
      remove.textContent = `Remove Selected (${selected})`;
    }
    all.addEventListener('change', () => {
      picks.forEach((pick) => { pick.checked = all.checked; });
      syncSelection();
    });
    picks.forEach((pick) => pick.addEventListener('change', syncSelection));
    syncSelection();

    remove.addEventListener('click', () => {
      const count = picks.filter((pick) => pick.checked).length;
      if (!count || !window.confirm(`Remove ${count} selected item${count === 1 ? '' : 's'} from your cart?`)) return;
      picks.forEach((pick) => {
        if (pick.checked) pick.closest('[data-cart-item]').querySelector('[name="updates[]"]').value = 0;
      });
      submitUpdate();
    });

    form.querySelectorAll('[data-step]').forEach((button) => {
      button.addEventListener('click', () => {
        const input = button.parentElement.querySelector('[name="updates[]"]');
        const next = Math.max(1, Number(input.value || 1) + Number(button.dataset.step));
        input.value = input.max ? Math.min(next, Number(input.max)) : next;
        submitUpdate();
      });
    });
  }

  function init(root = document) {
    if (root.matches?.('[data-nwan-cart]')) initCart(root);
    root.querySelectorAll('[data-nwan-cart]').forEach(initCart);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
